<div class="grid hidden md:flex">
    <!-- Use async pipe to properly handle session observable -->
    <ng-container *ngIf="myAuthService.session$ | async as session">
        <!-- Layout when BDE is available (BDE == 1) -->
        <ng-container *ngIf="session.BDE == 1">
            <div class="col-12 md:col-6">
                <div>
                    <ng-container [ngTemplateOutlet]="welcome"></ng-container>
                </div>
                <div class="mt-2">
                    <ng-container [ngTemplateOutlet]="booking"></ng-container>
                </div>
                <!-- Quick Access Widget - only show if entries exist AND BDE permission -->
                <div class="mt-2" *ngIf="session.BDE == 1 && (quickAccessEntries$ | async)?.length > 0">
                    <ng-container [ngTemplateOutlet]="quickAccess"></ng-container>
                </div>
            </div>
            <div class="col-12 md:col-6">
                <ng-container class="mb-2" [ngTemplateOutlet]="userStatus"></ng-container>
                <div [ngClass]="{'mt-2': !pinLoggedIn}">
                    <tx-bde></tx-bde>
                </div>
            </div>
        </ng-container>
        
        <!-- Layout when BDE is not available (BDE != 1) - single column, centered -->
        <ng-container *ngIf="session.BDE != 1">
            <div class="col-12 md:col-8 md:col-offset-2 lg:col-8 lg:col-offset-2">
                <div>
                    <ng-container [ngTemplateOutlet]="welcome"></ng-container>
                </div>
                <div class="mt-2">
                    <ng-container [ngTemplateOutlet]="booking"></ng-container>
                </div>
                <!-- Quick Access Widget - only show if entries exist AND BDE permission -->
                <div class="mt-2" *ngIf="session.BDE == 1 && (quickAccessEntries$ | async)?.length > 0">
                    <ng-container [ngTemplateOutlet]="quickAccess"></ng-container>
                </div>
                <div class="mt-2">
                    <ng-container [ngTemplateOutlet]="userStatus"></ng-container>
                </div>
            </div>
        </ng-container>
    </ng-container>
</div>

<!-- Mobile Layout -->
<div class="grid hidden-md-up">
    <ng-container *ngIf="myAuthService.session$ | async as session">
        <div class="col-12 md:col-6">
            <div class="mb-2">
                <ng-container [ngTemplateOutlet]="booking"></ng-container>
            </div>
            <!-- Quick Access Widget for Mobile - only show if entries exist AND BDE permission -->
            <div class="mb-2" *ngIf="session.BDE == 1 && (quickAccessEntries$ | async)?.length > 0">
                <ng-container [ngTemplateOutlet]="quickAccess"></ng-container>
            </div>
            <div class="mb-2" *ngIf="session.BDE == 1">
                <tx-bde></tx-bde>
            </div>
            <div class="mb-2">
                <ng-container [ngTemplateOutlet]="userStatus"></ng-container>
            </div>
            <ng-container [ngTemplateOutlet]="welcome"></ng-container>
        </div>
    </ng-container>
</div>

<!-- Driver's License Control Section for Mobile/Tablet -->
<div class="grid" *ngIf="listOfUserInfo?.fs_control == 1 && (isMobile || isTablet) && goodConnection && !pinLoggedIn">
    <div class="col-12 md:col-6 disabled-exact" [ngClass]="{ 'disabled-overlay': !networkIsOnline }">
        <tx-imageupload
                (upload)="onFileUpload($event)"
                [(blockui)]="blockImageUploadUi"
                [forceDesktop]="false"
                [title]="'txTeamleiter.driverLicenseCheck' | translate"
                [description]="'txBuchungen.fsPhotoPrompt' | translate"
                [chooseLabel]="'txBuchungen.startPhoto' | translate">
        </tx-imageupload>
    </div>
</div>

<!-- Welcome Template -->
<ng-template #welcome>
    <tx-welcome
            [offlineBookings]="(queueSize$ | async)?.length || 0"
            [listOfUserInfo]="listOfUserInfo"
            [hideTitle]="isMobile">
    </tx-welcome>
</ng-template>

<!-- User Status Template -->
<ng-template #userStatus>
    <ng-container *ngIf="!pinLoggedIn && myTabStateService.TabStates$ | async as TabStates">
        <mat-accordion>
            <mat-expansion-panel
                    class="mat-elevation-z0"
                    hideToggle
                    (opened)="onTabOpen('us1')"
                    (closed)="onTabClose('us1')"
                    [expanded]="TabStates.us1">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="flex space-x-2">
                            <div class="ml-1">
                                <div class="transition-all rotate-0 {{ TabStates.us1 ? 'rotate-90' : '' }}">
                                    <fa-icon icon="chevron-right"></fa-icon>
                                </div>
                            </div>
                            <div class="text-xl font-bold">
                                {{ 'txBuchungen.userState' | translate }}
                            </div>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div>
                    <div class="flex space-x-2">
                        <mat-form-field class="w-100" appearance="outline">
                            <mat-label>{{ 'txBuchungen.chooseState' | translate }}</mat-label>
                            <mat-select [(ngModel)]="SelectedState" (selectionChange)="setUserState()">
                                <mat-option *ngFor="let state of UserStates$ | async" [value]="state.value">
                                    {{ state.label | translateOrText: 'userStates.' }}
                                </mat-option>
                            </mat-select>
                            <div matSuffix class="flex space-x-4">
                                <mat-icon
                                        matRipple
                                        click-stop-propagation
                                        class="flex justify-center ml-2 mb-2 rounded-full cursor-pointer text-red-500 p-2 bg-red-500/20"
                                        style="height: 44px; width: 44px;"
                                        (click)="SelectedState = '0'; setUserState()">
                                    <fa-icon icon="times"></fa-icon>
                                </mat-icon>
                            </div>
                        </mat-form-field>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </ng-container>
</ng-template>

<ng-template #booking>
    <ng-container *ngIf="myAuthService.session$ | async as session">
        <ng-container *ngIf="myTabStateService.TabStates$ | async as TabStates">
            <mat-accordion>
                <mat-expansion-panel
                        class="mat-elevation-z0"
                        hideToggle
                        (opened)="onTabOpen('b1')"
                        (closed)="onTabClose('b1')"
                        [expanded]="TabStates?.b1">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <div class="flex space-x-2">
                                <div class="ml-1">
                                    <div class="transition-all rotate-0 {{ TabStates.b1 ? 'rotate-90' : '' }}">
                                        <fa-icon icon="chevron-right"></fa-icon>
                                    </div>
                                </div>
                                <div class="text-xl font-bold">
                                    {{ 'txBuchungen.timeRegistration' | translate }}
                                </div>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div>
                        <!-- Auto Booking Section -->
                        <div class="grid" *ngIf="session.bookAuto == 1">
                            <div class="col-12">
                                <button mat-raised-button color="primary" class="w-full text-lg py-2" (click)="clickBookingButton('K')"
                                        name="btnBuchung">
                                    <i class="far fa-clock mr-2" style="font-size: 18px;"></i>
                                    {{ 'txBuchungen.booking' | translate }}
                                </button>
                            </div>
                        </div>

                        <!-- Arrive/Go Section -->
                        <div class="grid" *ngIf="session.Kommen == 1">
                            <!-- Simple Arrive Button -->
                            <div class="col-12 lg:col-6" *ngIf="session.KST == 0">
                                <button mat-raised-button color="primary" class="w-full text-lg py-2" (click)="clickBookingButton('K')"
                                        name="btnKommen">
                                    {{ 'txBuchungen.arrive' | translate }}
                                </button>
                            </div>

                            <!-- Arrive with Cost Centers -->
                            <div class="col-12 lg:col-6" *ngIf="session.KST == 1">
                                <div class="flex w-full booking-split-button">
                                    <button mat-raised-button color="primary" class="flex-grow text-lg py-2" (click)="clickBookingButton('K')">
                                        {{ 'txBuchungen.arrive' | translate }}
                                    </button>
                                    <button mat-raised-button color="primary" [matMenuTriggerFor]="kstMenuArrive" [attr.aria-label]="'txBuchungen.costCenters' | translate" class="py-2">
                                        <mat-icon>arrow_drop_down</mat-icon>
                                    </button>
                                    <mat-menu #kstMenuArrive="matMenu">
                                        <button mat-menu-item *ngFor="let k of kostenstellen" (click)="k.command()">{{ k.label }}</button>
                                    </mat-menu>
                                </div>
                            </div>

                            <!-- Go Button -->
                            <div class="col-12 lg:col-6">
                                <button mat-raised-button color="primary" class="w-full text-lg py-2" (click)="clickBookingButton('G')">
                                    {{ 'txBuchungen.go' | translate }}
                                </button>
                            </div>
                        </div>

                        <!-- Break Section -->
                        <div class="grid" *ngIf="session.Pause == 1">
                            <div class="col-12 lg:col-6">
                                <button mat-raised-button color="primary" class="w-full text-lg py-2" (click)="clickBookingButton('PB')">
                                    {{ 'txBuchungen.beginOfBreak' | translate }}
                                </button>
                            </div>
                            <div class="col-12 lg:col-6">
                                <button mat-raised-button color="primary" class="w-full text-lg py-2" (click)="clickBookingButton('PS')">
                                    {{ 'txBuchungen.endOfBreak' | translate }}
                                </button>
                            </div>
                        </div>

                        <!-- Errand Section -->
                        <div class="grid" *ngIf="session.Dienstgang == 1">
                            <div class="col-12 lg:col-6">
                                <button mat-raised-button color="primary" class="w-full text-lg py-2" (click)="clickBookingButton('DB')">
                                    {{ 'txBuchungen.beginOfErrand' | translate }}
                                </button>
                            </div>
                            <div class="col-12 lg:col-6">
                                <button mat-raised-button color="primary" class="w-full text-lg py-2" (click)="clickBookingButton('DE')">
                                    {{ 'txBuchungen.endOfErrand' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </ng-container>
    </ng-container>
</ng-template>

<!-- Quick Access Widget (Direktwahl) - Separate widget below time registration -->
<ng-template #quickAccess>
    <ng-container *ngIf="myTabStateService.TabStates$ | async as TabStates">
        <mat-accordion>
            <mat-expansion-panel
                    class="mat-elevation-z0"
                    hideToggle
                    (opened)="onTabOpen('qa1')"
                    (closed)="onTabClose('qa1')"
                    [expanded]="TabStates?.qa1">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="flex space-x-2">
                            <div class="ml-1">
                                <div class="transition-all rotate-0 {{ TabStates.qa1 ? 'rotate-90' : '' }}">
                                    <fa-icon icon="chevron-right"></fa-icon>
                                </div>
                            </div>
                            <div class="text-xl font-bold">
                                {{ (quickAccessTitle$ | async) || ('txBuchungen.quickAccess' | translate) }}
                            </div>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div>
                    <!-- Quick Access Buttons Grid - only show entries, no empty/loading state needed -->
                    <!-- Widget is hidden by parent if no entries exist -->
                    <ng-container *ngIf="quickAccessEntries$ | async as entries">
                        <div class="grid">
                            <div class="col-12 lg:col-6" *ngFor="let entry of entries">
                                <button mat-raised-button color="primary" class="w-full text-lg py-2" (click)="startQuickAccessBooking(entry)">
                                    <i class="fas fa-bolt mr-2"></i>
                                    {{ entry.bezeichnung }}
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </ng-container>
</ng-template>
